import React, { useMemo } from 'react';

export type DropdownOption = string | { value: string; label: string };

interface IDropdownProps {
    id: string;
    value: string;
    options?: DropdownOption[];
    label?: string;
    title?: string;
    disabled?: boolean;
    placeholder?: string;
    className?: string;
    onChange: (value: string) => void;
}

export const Dropdown: React.FC<IDropdownProps> = ({
    id,
    value,
    options = [],
    label,
    title,
    disabled = false,
    placeholder,
    className,
    onChange
}) => {
    const normalizedOptions = useMemo(() => {
        return options.map((option: DropdownOption) => {
            if (typeof option === 'string') {
                return { value: option, label: option };
            }
            return option;
        });
    }, [options]);

    return (
        <div className={className}>
            {label && <label htmlFor={id}>{label}</label>}
            <select id={id} value={value} onChange={e => onChange(e.target.value)} disabled={disabled} title={title || label}>
                {placeholder && (
                    <option value='' hidden>
                        {placeholder}
                    </option>
                )}
                {normalizedOptions.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Dropdown;
